<!--<ui-product-list-filter [searchParams]="searchParams()"></ui-product-list-filter>-->

@if (initialSearch()) {
  <ui-product-list-skeleton [count]="10"></ui-product-list-skeleton>
}

@if (this.searchResults$ | async; as searchResults) {
  <div class="wrapper-plp">
    <ui-category-side-menu
      [navItems]="searchResults.filterConfig.categoryTreeFilter"
      [selectedItemId]="searchResults.filterConfig.currentCategoryFilterValue"
      (selectedItemChange)="onSideMenuItemSelect($event)">
    </ui-category-side-menu>
    @if (searchResults.products.length > 0) {
      <div class="wrapper-search-results">
        <ui-product-category-banner [contentId]="currentNavigationNode()?.categoryBannerContentId"></ui-product-category-banner>
        <ui-catalog-search-filter-sort
          (valueChange)="onFilterSortChange($event)"
          [filterConfig]="searchResults.filterConfig"
          [sortConfig]="searchResults.sortConfig">
        </ui-catalog-search-filter-sort>
        <h1 class="search-results">{{ searchResults.pagination.found }} Artikel gefunden</h1>
        <ui-product-list
          [indexBase]="searchResults.pagination.page * searchResults.pagination.config.pageSize"
          [products]="searchResults.products"
          (addToShoppingList)="addToShoppingListDialog.openDialogWithProduct($event.item, $event.quantity)"
        ></ui-product-list>
        <ui-paginator
          [pageIndex]="searchResults.pagination.page"
          [length]="searchResults.pagination.found"
          [pageSize]="searchResults.pagination.config.pageSize"
          [pageSizeOptions]="searchResults.pagination.config.pageSizeOptions"
          [showFirstLastButtons]="true"
          [title]="'Produkte'"
          (page)="onPageChange($event)"
        ></ui-paginator>
      </div>
    } @else {
      <div class="no-products-container">
        @if (searchParamsHasQuery()) {
          <div class="no-products-found">
            <ui-icon class="item-empty" faName="empty-set" faStyle="light"></ui-icon>
            <h1>0 Treffer</h1>
            <p>Für Ihre Suche wurden keine Produkte gefunden.<br>Bitte passen Sie ihre Suche an.</p>
          </div>
        } @else {
          <div class="no-search-result">
            <ui-icon class="item-box" faName="box-open" faStyle="light"></ui-icon>
            <div class="no-search-result-content">
              <h3>Aktuell keine Artikel verfügbar</h3>
              <p>Bitte wenden Sie sich bei Interesse an Artikeln in dieser Kategorie an Ihren Lekkerland-Ansprechpartner.</p>
            </div>
          </div>
        }
      </div>
    }
  </div>
}

<ui-add-to-shopping-list-dialog #addToShoppingListDialog></ui-add-to-shopping-list-dialog>
